import EscLogo from '../images/esc_logo.png'
import FieldEdgeLogo from '../images/fieldedge_logo.png'
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import React from 'react';
import Select from 'react-select/lib/Creatable';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';

import OTHER_SYSTEMS from '../util/otherSoftware'


const styles = theme => ({
  softwareLogo: {
    height: 36,
    verticalAlign: 'middle',
  },
});


class SystemSelection extends React.Component {

  state = {
    otherValue: ''
  }

  render = () => {
    const {classes, data, actions} = this.props
    const {otherValue} = this.state
    const software = data.software || {}

    const selectedSoftware = software.name || ''
    const selectedSoftwareValue = selectedSoftware.toLowerCase()

    // Show the option they picked if they leave and return to the page
    let defaultOtherOption = OTHER_SYSTEMS.filter(o => o.value === selectedSoftware)[0] || {label: selectedSoftware, value: selectedSoftware}

    const otherSelected = (
      typeof software.name  !== "undefined" &&
      selectedSoftwareValue !== "fieldedge" &&
      selectedSoftwareValue !== "esc" &&
      selectedSoftwareValue !== "none"
    )

    // Don't set a default value in the "Other" dropdown if Other isn't selected
    if (!otherSelected) defaultOtherOption = ''

    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          What Software Do You Use?
        </Typography>

        <Grid container spacing={24} style={{marginLeft:8, marginTop: 24}}>
          <Grid item xs={12} sm={12}>
            <SoftwareRadioButton
              onChange={actions.setSoftwareName}
              className={classes.option}
              value="fieldedge"
              checked={selectedSoftwareValue === "fieldedge"}
              label={<img alt="FieldEdge" src={FieldEdgeLogo} className={classes.softwareLogo}/>}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <SoftwareRadioButton
              onChange={actions.setSoftwareName}
              className={classes.option}
              value="esc"
              checked={selectedSoftwareValue === "esc"}
              label={<img alt="ESC" src={EscLogo} className={classes.softwareLogo}/>}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <SoftwareRadioButton
              onChange={() => {actions.setSoftwareName(otherValue)}}
              className={classes.textOption}
              value="other"
              checked={otherSelected}
              label="Other"
            />
            <Typography variant="body2" component="div" style={{marginLeft: 40, marginRight: 40}}>
              <Select
                options={OTHER_SYSTEMS}
                defaultValue={defaultOtherOption}
                onChange={option => {this.setState({otherValue: option.value}); actions.setSoftwareName(option.value)}}
                isDisabled={!otherSelected}
                formatCreateLabel={val => val + ' (Custom Software - Press Enter to Add)'}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12}>
            <SoftwareRadioButton
              onChange={actions.setSoftwareName}
              className={classes.textOption}
              value="none"
              checked={selectedSoftwareValue === "none"}
              label="No Software"
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(SystemSelection);




const radioStyles = theme => ({
  label: {
    padding: 0,
    margin: 0,
    fontSize: '1.1em',
    flexGrow: 1,
    cursor: 'pointer',
    marginRight: theme.spacing.unit * 4,
  },
})

function SoftwareRadioButtonCore(props) {
  const id= "software-" + props.value
  return (
    <div style={{display: 'flex', alignItems: 'center'}}>
      <Radio
        id={id}
        className={props.classes.radio}
        checked={props.checked}
        onChange={() => props.onChange(props.value)}
      />
      <Typography
        variant="body2"
        component="label"
        className={props.classes.label}
        htmlFor={id}
      >
        {props.label}
      </Typography>
    </div>
  )
}

const SoftwareRadioButton = withStyles(radioStyles)(SoftwareRadioButtonCore)
